/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Work_CaptionInputs */

const en_home_work_caption = /** @type {(inputs: Home_Work_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a task. Review the result.`)
};

const lv_home_work_caption = /** @type {(inputs: Home_Work_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izvēlieties uzdevumu. Izvērtējiet rezultātu.`)
};

/**
* | output |
* | --- |
* | "Choose a task. Review the result." |
*
* @param {Home_Work_CaptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_work_caption = /** @type {((inputs?: Home_Work_CaptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Work_CaptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_work_caption(inputs)
	return en_home_work_caption(inputs)
});